import { useCounter } from '../hooks/useObserver';

export default function Counter({ n, suf = '' }) {
  const [value, ref] = useCounter(n);
  return (
    <span ref={ref} style={{ fontFamily:'var(--fH)', fontSize:'clamp(2rem,4vw,3rem)', color:'var(--o)', letterSpacing:'2px' }}>
      {value}{suf}
    </span>
  );
}
